import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ApiMiniPaymentMethodsService } from './infrastructure/api/api-mini-payment-methods.service';
import { ApiMiniPaymentMethodsTransformer } from './infrastructure/api/api-mini-payment-methods.transformer';
import { MiniPaymentMethodsComponent } from './mini-payment-methods.component';

import { StaticResourceService } from '@core/services/static-resource.service';

@NgModule({
    declarations: [
        MiniPaymentMethodsComponent,
    ],
    providers: [
        ApiMiniPaymentMethodsService,
        ApiMiniPaymentMethodsTransformer,
        StaticResourceService,
    ],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
    ],
    exports: [
        MiniPaymentMethodsComponent,
    ],
})
export class MiniPaymentMethodsModule {
}
